import { useContext, useEffect, useRef, useState } from "react";

import { api_without_cancellation } from "../../../../api/api";
import { CaseNavigatorModalContext } from "../../CaseNavigatorModalContext";
import { setEqualColumnWidthsState } from "../../../../Utils/helper";

const StateTab = ({ caseTypes, currentFilter, rowCount, onCaseTypeAvailabilityChange }) => {
  const [StatesList, setStatesList] = useState([]);
  const [CaseStateVenueData, setStateVenueData] = useState([]);
  const { handleShowModal } = useContext(CaseNavigatorModalContext);
  // const fetchStateVenueData = async (currentFilter2) => {
  //   const statevenue_data = await api_without_cancellation.get(
  //     "/api/navigator/navigator_statevenue_data/",
  //     currentFilter2
  //       ? {
  //           params: {
  //             [currentFilter2.type]: currentFilter2.name || "",
  //           },
  //         }
  //       : {}
  //   );
  //   setStateVenueData(statevenue_data.data.case_states_venue_data);
  //   setStatesList(statevenue_data.data.states_list);
  // };

  const fetchStateVenueData = async (currentFilter2) => {
    try {
      const res = await api_without_cancellation.get(
        "/api/navigator/navigator_statevenue_data/",
        currentFilter2
          ? {
              params: {
                [currentFilter2.type]: currentFilter2.name || "",
              },
            }
          : {}
      );

      const data = res?.data?.case_states_venue_data ?? [];
      setStateVenueData(data);
      setStatesList(res?.data?.states_list ?? []);
      onCaseTypeAvailabilityChange?.(
        new Set(
          data
            .filter((row) => row.some((item) => item.count > 0))
            .flatMap((row) => {
              const item = row[0];
              const keys = [];
              if (item?.case_type_id !== null && item?.case_type_id !== undefined) {
                keys.push(`id:${item.case_type_id}`);
              }
              if (item?.case_type) {
                keys.push(`name:${item.case_type.trim().toLowerCase()}`);
              }
              return keys;
            })
        )
      );
    } catch (error) {
      console.error("Failed to fetch state venue data:", error);
      setStateVenueData([]);
      setStatesList([]);
      onCaseTypeAvailabilityChange?.(new Set());
    }
  };

  useEffect(() => {
    fetchStateVenueData(currentFilter);
  }, [currentFilter]);

  // const getSpanText = (spanClass) => {
  //   switch (spanClass) {
  //     case "span_1_D":
  //       return "between 0 Day and 1 Day";
  //     case "span_2_D":
  //       return "between 1 Day and 2 Day";
  //     case "span_3_D":
  //       return "between 2 Day and 3 Day";
  //     case "span_1_Wk":
  //       return "between 3 Day and 1 Week";
  //     case "span_2_Wks":
  //       return "between 1 Week and 2 Weeks";
  //     case "span_1_Mo":
  //       return "between 2 Week and 1 Month";
  //     case "span_2_Mos":
  //       return "between 1 Month and 2 Months";
  //     case "span_3_Mos":
  //       return "between 2 Months and 3 Months";
  //     case "span_6_Mos":
  //       return "between 3 Months and 6 Months";
  //     case "span_1_Yr":
  //       return "between 6 Months and 1 Year";
  //     case "span_2_Yrs":
  //       return "between 1 Year and 2 Years";
  //     case "span_3_Yrs":
  //       return "between 2 Years and 3 Years";
  //     case "span_5_Yrs":
  //       return "between 3 Years and 5 Years";
  //     case "span_greater_5_Yrs":
  //       return "more than 5 Years";
  //     default:
  //       return "";
  //   }
  // };
  const openModal = (caseType, tabValue, caseTypeId) => () => {
    // const span = getSpanText(tabValue);
    // const typeText = caseType === "" ? "All Case Types" : caseType;
    // const stageText = activeStage === "all_stage" ? "All Stages" : activeStage;
    // const statusText = activeStatus === "all_status" ? "All Statuses" : activeStatus;

    // const headerString = `${typeText} Cases sorted by ${stageText}, ${statusText} with Case Age ${span}`;
    // const span = getSpanText(tabValue);
    // const typeText = caseType === "" ? "All Case Types" : caseType;
    // const hasFilter = currentFilter && currentFilter.name;

    const typeText = caseType === "" ? "All Case Types" : caseType;
    const hasFilter = currentFilter && currentFilter.name;

    const headerString = hasFilter
      ? `${typeText} cases filtered by ${currentFilter.name}, for ${tabValue}`
      : `${typeText} cases for ${tabValue}.`;

    handleShowModal({
      caseType: caseType,
      // Status: "All Statuses",
      // Stage: "All Stages",
      CurrentFilter: currentFilter,
      tabName: "State",
      tabValue: tabValue,
      headerString: headerString,
      caseTypeId: caseTypeId,
      range: tabValue,
    });
  };
  const tableRef = useRef(null);
  const aggregateRow = CaseStateVenueData.find((row) => !row[0]?.case_type);
  const orderedCaseRows = caseTypes.map(
    (caseType) =>
      CaseStateVenueData.find((row) => row[0]?.case_type === caseType.name) ||
      StatesList.map((state) => ({
        count: 0,
        case_type: caseType.name,
        state_name: state.name,
      }))
  );
  const displayRows = aggregateRow ? [aggregateRow, ...orderedCaseRows] : orderedCaseRows;

  useEffect(() => {
    setEqualColumnWidthsState(tableRef);
    window.addEventListener("resize", () => setEqualColumnWidthsState(tableRef));
    return () => {
      window.removeEventListener("resize", () => setEqualColumnWidthsState(tableRef));
    };
  }, [CaseStateVenueData]);

  return (
    <>
      <div>
        <table
          ref={tableRef}
          className="table res_tab table-navi-different table-responsive ms-0 equal-column-width-table navigator-standard-table-header"
        >
          <tbody className="Index-width-webkit-fill-available-display-inline-table">
            <tr className="thead">
              {StatesList.map((state, index) => (
                <th key={"th-" + index} title={state.name}>
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      gap: "5px",
                    }}
                  >
                    <svg
                      style={{
                        width: "19px",
                        height: "19px",
                        fill: "var(--primary-80)",
                        color: "var(--primary-80)",
                        stroke: "var(--primary-80)",
                      }}
                      className={`icon icon-state-${state?.stateAbr}`}
                    >
                      <use xlinkHref={`#icon-state-${state?.stateAbr}`} />
                    </svg>
                    {state.name}
                  </div>
                </th>
              ))}
            </tr>
            {displayRows
              .filter((case_data) => case_data.length > 0)
              .map((case_data, index) => (
                <tr key={index} className="h-25px">
                  {case_data.map((individual_data, idx) =>
                    individual_data.count > 0 ? (
                      <td
                        key={"td-" + idx}
                        className="h-25px cursor-pointer onHoverNewThings text-center"
                        onClick={openModal(
                          individual_data.case_type,
                          individual_data.state_name,
                          individual_data?.case_type_id || ""
                        )}
                      >
                        <p
                          className={individual_data.count > 0 ? "fw-bold" : "text-grey"}
                          data-state-class={individual_data.state_name + "_case"}
                          // data-status-class={activeStatus}
                          // data-stage-class={activeStage}
                          data-casetype={
                            individual_data.case_type
                              ? individual_data.case_type.replace(/\s/g, "")
                              : ""
                          }
                        >
                          {individual_data.count}
                        </p>
                      </td>
                    ) : (
                      <td
                        key={"td-" + idx}
                        className="h-25px onHoverNewThings cursor-pointer text-center"
                      >
                        <p
                          className={individual_data.count > 0 ? "fw-bold" : "text-grey"}
                          data-state-class={individual_data.state_name + "_case"}
                          // data-status-class={activeStatus}
                          // data-stage-class={activeStage}
                          data-casetype={
                            individual_data.case_type
                              ? individual_data.case_type.replace(/\s/g, "")
                              : ""
                          }
                        >
                          {/* {individual_data.count} */}
                        </p>
                      </td>
                    )
                  )}
                </tr>
              ))}
            {Array.from({ length: Math.max(0, rowCount - displayRows.length + 1) }).map(
              (_, rowIndex) => (
                <tr key={`state-empty-${rowIndex}`}>
                  {Array.from({ length: StatesList.length }).map((_, colIndex) => (
                    <td className="onHoverNewThings" key={colIndex} style={{ height: "25px" }} />
                  ))}
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default StateTab;
